import { Button, ButtonProps } from "@chakra-ui/react";

export type TabProps = Omit<ButtonProps, "color" | "colorScheme"> & {
  isActive?: boolean;
  activeColor?: ButtonProps["bg"];
  unactiveColor?: ButtonProps["bg"];
};

const Tab = ({
  isActive = false,
  activeColor = "primary.500",
  unactiveColor = "bright.50",
  ...rest
}: TabProps) => (
  <Button
    variant="ghost"
    color={isActive ? activeColor : unactiveColor}
    borderBottom="2px solid"
    borderBottomRadius="none"
    borderColor={isActive ? activeColor : "transparent"}
    {...rest}
  />
);

export default Tab;
